import React, { useEffect } from "react";
import profile from "./config/profile";
import { PROFILE_ENV } from "./config";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Portfolio from "./components/Portfolio";


function App() {
  const theme = profile?.theme === "light" ? "light" : "dark";

  useEffect(() => {
    if (profile && profile.projectTitle) {
      document.title = `Kodoth Group | ${profile.projectTitle}`;
    }

    const badgeNameElement = document.getElementById("portfolio-badge-name");
    if (badgeNameElement) {
      badgeNameElement.textContent = profile?.name || profile?.contact?.name || "Profile";
    }

    const badgeImageElement = document.getElementById("portfolio-badge-image");
    if (badgeImageElement && PROFILE_ENV) {
      badgeImageElement.setAttribute("src", `/assets/img/${PROFILE_ENV}-image.png`);
    }

    document.documentElement.classList.toggle("dark", theme === "dark");
    document.body.setAttribute("data-theme", theme);
  }, [theme]);

  return (
    <div className={`App ${theme === "light" ? "theme-light" : "theme-dark"}`}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;